import script from "./MobileReceivedReportList.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReceivedReportList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=cb63c25e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb63c25e"]])

export default __exports__